import { CoverLevelOption } from './types'

// keys are used for contextual help URLs
export type FeesBreakdown = {
  serviceFee?: number
}

export const getCoverLevelFeesBreakdown = (
  coverLevelOption?: CoverLevelOption,
): FeesBreakdown => {
  if (!coverLevelOption) return {}

  const rawFees: Record<keyof FeesBreakdown, number | null | undefined> = {
    // do not show service fee if it is 0
    serviceFee: coverLevelOption.serviceFeeAmt || undefined,
  }

  return Object.fromEntries(
    // filter out null and undefined values
    Object.entries(rawFees).filter(([, value]) => typeof value === 'number'),
  ) as FeesBreakdown
}
